<template>
  <div class="flex-1 flex-col w-full flex gap-24">
    <div class="flex flex-col gap-16">
      <h1 v-if="!isMobileScreenSize" class="text-4xl font-bold mb-8">
        {{ $t('health_actions.scheduling.select_availability_title') }}
      </h1>
      <H2 v-else class="font-semibold w-full text-lg">
        {{ $t('health_actions.scheduling.select_availability_title') }}
      </H2>
      <WarningBox
        :text="$t('health_actions.scheduling.select_availability_description')"
      />
    </div>
    <div
      :class="
        isMobileScreenSize
          ? 'flex flex-col w-full gap-16'
          : 'grid grid-cols-2 gap-24'
      "
    >
      <DayAvailability
        v-for="day in Object.keys(selectedAvailability)"
        :key="day"
        :day="day"
        :isExpanded="expanded[day].isExpanded"
        @toggle="expanded[day].isExpanded = !expanded[day].isExpanded"
      />
    </div>
  </div>
</template>

<script>
import DayAvailability from './DayAvailability.vue'
import WarningBox from './WarningBox.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { mapGetters } from 'vuex'
import { SCHEDULING_AVAILABILITY } from '@platform-shared/constants'
import H2 from '~/components/common/Typography/H2.vue'

export default {
  components: {
    DayAvailability,
    WarningBox,
    H2,
  },
  mixins: [screenSizeMixin],
  data() {
    return {
      expanded: {
        [SCHEDULING_AVAILABILITY.DAYS.MONDAY]: { isExpanded: false },
        [SCHEDULING_AVAILABILITY.DAYS.TUESDAY]: { isExpanded: false },
        [SCHEDULING_AVAILABILITY.DAYS.WEDNESDAY]: { isExpanded: false },
        [SCHEDULING_AVAILABILITY.DAYS.THURSDAY]: { isExpanded: false },
        [SCHEDULING_AVAILABILITY.DAYS.FRIDAY]: { isExpanded: false },
        [SCHEDULING_AVAILABILITY.DAYS.SATURDAY]: { isExpanded: false },
        [SCHEDULING_AVAILABILITY.DAYS.SUNDAY]: { isExpanded: false },
      },
    }
  },
  computed: {
    ...mapGetters('scheduling', ['selectedAvailability']),
  },
}
</script>
